import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  inject,
  output,
} from '@angular/core';

/** Formats a card number as `#### #### #### ####` and detects the brand. */
@Directive({
  selector: '[libCardNumberFormat]',
})
export class CardNumberFormatDirective {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  readonly cardTypeDetected = output<{
    cardType: string | null;
    value: string;
  }>();

  @HostListener('input') onInput(): void {
    this.formatAndDetectCardType();
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const numericOnly = pastedText.replace(/\D/g, '');
    const formatted = this.formatText(numericOnly);
    this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
    this.detectCardType(numericOnly, formatted);
  }

  private formatAndDetectCardType(): void {
    const input = this.el.nativeElement.value.replace(/\D/g, '');
    const formattedInput = this.formatText(input);
    this.renderer.setProperty(this.el.nativeElement, 'value', formattedInput);
    this.detectCardType(input, formattedInput);
  }

  private formatText(input: string): string {
    return input.replace(/(.{4})/g, '$1 ').trim();
  }

  private detectCardType(cardNumber: string, value: string): void {
    let cardType: string | null = null;

    if (/^4/.test(cardNumber)) {
      cardType = 'Visa';
    } else if (/^5[1-5]/.test(cardNumber) || /^2(2[2-9]|[3-7][0-9])/.test(cardNumber)) {
      cardType = 'MasterCard';
    }

    this.cardTypeDetected.emit({ cardType, value });
  }
}
